module.exports = __webpack_public_path__ + "img/attach-green.223f0aca.svg";